/**
 * Mopper · Espace éditorial /guides — SOURCE DE VÉRITÉ UNIQUE (scalable).
 *
 * Les contenus vivent dans `src/data/guides.data.json`, consommé à la fois par
 * le runtime React (ce module) et par le générateur de snapshots Python
 * (parité SEO). Pour ajouter un guide : éditer le JSON. Le temps de lecture est
 * calculé automatiquement.
 */
import data from "@/data/guides.data.json";

export const GUIDE_CATEGORIES = data.categories;
export const GUIDES = data.guides;

export function readingTime(guide) {
  let words = 0;
  for (const s of guide.sections) {
    words += (s.h2 || "").split(/\s+/).length;
    for (const p of s.p || []) words += p.split(/\s+/).length;
    for (const li of s.list || []) words += li.split(/\s+/).length;
  }
  return Math.max(2, Math.round(words / 200));
}

export function getGuide(slug) {
  return GUIDES.find((g) => g.slug === slug) || null;
}
